/*
 * @Description:
 * @Autor: panmy
 * @Date: 2024-04-17 15:23:38
 * @LastEditors: panmy
 * @LastEditTime: 2024-11-07 14:10:30
 */
import * as CryptoJS from "crypto-js"; // base64解密

/**
 * 延迟
 * @param time 毫秒数
 */
export function delay(time = 1500) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

// token 格式化
export function authorizationFormat(token) {
  return `Bearer ${token}`;
}

// export let getUrlParam = name => {
//   let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
//   let r = window.location.search.substr(1).match(reg);
//   if (r != null) return decodeURI(unescape(r[2]));
//   return '';
// };

export let getUrlParam = (name) => {
  let u = window.location.href,
    reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
    r = u.substr(u.indexOf("?") + 1).match(reg);
  return r != null ? decodeURI(r[2]) : "";
};

export function validateObject(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
        return false;
      }
    }
  }
  return true;
}

export function delAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--; ) {
      document.cookie =
        keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); //清除当前域名下
      document.cookie =
        keys[i] +
        "=0;path=/;domain=" +
        document.domain +
        ";expires=" +
        new Date(0).toUTCString();
      document.cookie = keys[i] + new Date(0).toUTCString();
    }
  }
}

export function encryptAES(word, keyStr) {
  keyStr = keyStr ? keyStr : "jsmituluzhou2024";
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}
